import {useEffect, useState} from "react";

import SoccerLineup from "react-soccer-lineup";

// import "./index.scss";

export default function SoccerField(props) {
	const {size = "responsive", homeModule, awayModule} = props;

	const [homeSquad, setHomeSquad] = useState({});
	const [awaySquad, setAwaySquad] = useState({});

	useEffect(() => {
		const hs = {
			df: [],
			cm: [],
			cam: [],
			fw: [],
		};
		if (homeModule?.df) {
			hs.gk = {};
			for (let i = 0; i < homeModule.df; i++) {
				hs.df.push({});
			}
			for (let i = 0; i < homeModule.cm; i++) {
				hs.cm.push({});
			}
			for (let i = 0; i < homeModule.fw; i++) {
				hs.fw.push({});
			}
		}

		setHomeSquad(hs);
	}, [homeModule]);

	useEffect(() => {
		const as = {df: [], cm: [], fw: []};
		if (awayModule?.df) {
			as.gk = {};
			for (let i = 0; i < awayModule.df; i++) {
				as.df.push({});
			}
			for (let i = 0; i < awayModule.cm; i++) {
				as.cm.push({});
			}
			for (let i = 0; i < awayModule.fw; i++) {
				as.fw.push({});
			}
		}

		setAwaySquad(as);
	}, [awayModule]);

	const homeTeam = {
		squad: homeSquad,
	};

	const awayTeam = {
		squad: awaySquad,
	};

	return <SoccerLineup size={size} homeTeam={homeTeam} awayTeam={awayTeam} />;
}
